/* Standalone popup. Manual labels are merchant-configured; no live order feed. */
if (!customElements.get('riot-notification-popup')) {
  customElements.define('riot-notification-popup', class extends HTMLElement {
    connectedCallback() {
      this.stopped = false;
      this.abort = new AbortController();
      this.index = 0;
      this.key = 'riot-notification-dismissed-until';
      this.products = Array.from(this.querySelectorAll('[data-product]'), el => ({ ...el.dataset }));
      if (!this.products.length) return;
      if (this.dataset.designMode !== 'true') {
        try { if (Number(localStorage.getItem(this.key)) > Date.now()) return; } catch (_) {}
      }
      this.interval = Math.max(5, Number(this.dataset.interval) || 20) * 1000;
      this.duration = Math.max(3, Number(this.dataset.duration) || 8) * 1000;
      this.entries = this.products;
      if (this.dataset.mode === 'manual') {
        this.locations = this.parseList('[data-locations]');
        this.times = this.parseList('[data-times]');
        if (!this.locations.length || !this.times.length) this.entries = [];
      }
      if (!this.entries.length) return;
      this.querySelector('[data-close]').addEventListener('click', () => {
        try { if (this.dataset.designMode !== 'true') localStorage.setItem(this.key, String(Date.now() + 86400000)); } catch (_) {}
        clearTimeout(this.timer); this.hide(); this.stopped = true;
      }, { signal: this.abort.signal });
      document.addEventListener('visibilitychange', () => {
        clearTimeout(this.timer);
        this.hide();
        if (!document.hidden && !this.stopped) this.schedule(this.interval);
      }, { signal: this.abort.signal });
      this.schedule(Math.max(0, Number(this.dataset.delay) || 0) * 1000);
    }
parseList(selector) {
  return String(this.querySelector(selector)?.value || '')
    .replace(/<!--[\s\S]*?-->/g, '')
    .split('|')
    .map(value => value.trim())
    .filter(Boolean);
}
    
    pick(list) { return list[Math.floor(Math.random() * list.length)]; }
    timeLabel(value) {
      return /(?:\bago|\bnow)$/i.test(value) ? value : value + ' ago';
    }
    schedule(delay) { clearTimeout(this.timer); this.timer = setTimeout(() => this.showNext(), delay); }
    blocked() {
      return document.hidden || (innerWidth < 768 && !this.classList.contains('show_someone_purchase_mobile')) ||
        !!document.querySelector('cart-drawer.active, quick-add-modal[open], dialog[open], .menu-drawer-container[open]');
    }
    showNext() {
      if (this.stopped || !this.isConnected) return;
      if (this.blocked() || this.contains(document.activeElement)) { this.schedule(1000); return; }
      if (!this.entries.length) { this.hide(); return; }
      const entry = this.dataset.mode === 'manual' ? this.pick(this.entries) : this.entries[this.index++ % this.entries.length];
      this.querySelector('[data-label]').textContent = this.dataset.mode === 'manual' ? 'Someone purchased' : 'Snack worth discovering';
      const title = this.querySelector('[data-name]');
      title.textContent = this.shortTitle(entry.title); title.href = entry.url; title.tabIndex = 0;
      const link = this.querySelector('[data-image-link]'); link.href = entry.url; link.tabIndex = 0;
      const image = this.querySelector('[data-image]');
      image.hidden = !entry.image; image.alt = entry.title;
      if (entry.image) image.src = entry.image; else image.removeAttribute('src');
      const detail = this.dataset.mode === 'manual' ? this.timeLabel(this.pick(this.times)) + ' from ' + this.pick(this.locations) : entry.price;
      this.querySelector('[data-detail]').textContent = detail;
      this.inert = false; this.classList.add('is-active');
      clearTimeout(this.timer); this.timer = setTimeout(() => this.endDisplay(), this.duration);
    }
    endDisplay() {
      if (this.contains(document.activeElement) || this.matches(':hover')) {
        this.timer = setTimeout(() => this.endDisplay(), 1000); return;
      }
      this.hide(); this.schedule(this.interval);
    }
    shortTitle(title) {
      const text = String(title || '').replace(/\s+/g, ' ').trim();
      if (text.length <= 60) return text;
      const slice = text.slice(0, 60);
      const boundary = slice.lastIndexOf(' ');
      return (boundary > 30 ? slice.slice(0, boundary) : slice).trimEnd() + '…';
    }
    hide() { this.classList.remove('is-active'); this.inert = true; }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
}
